import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/api';

// Async thunks
export const fetchPromotions = createAsyncThunk(
  'promotions/fetchAll',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.promotions.getAll(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createPromotion = createAsyncThunk(
  'promotions/create',
  async (promotionData, { rejectWithValue }) => {
    try {
      const response = await apiService.promotions.create(promotionData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const sendPromotion = createAsyncThunk(
  'promotions/send',
  async ({ id, recipients }, { rejectWithValue }) => {
    try {
      const response = await apiService.promotions.send(id, recipients);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updatePromotion = createAsyncThunk(
  'promotions/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiService.promotions.update(id, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  promotions: [],
  currentPromotion: null,
  loading: false,
  error: null,
  filters: {
    type: 'all',
    status: 'all',
    search: '',
  },
};

const promotionsSlice = createSlice({
  name: 'promotions',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setCurrentPromotion: (state, action) => {
      state.currentPromotion = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPromotions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPromotions.fulfilled, (state, action) => {
        state.loading = false;
        state.promotions = action.payload.data || action.payload;
      })
      .addCase(fetchPromotions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createPromotion.fulfilled, (state, action) => {
        state.promotions.unshift(action.payload);
      })
      .addCase(sendPromotion.fulfilled, (state, action) => {
        const promotion = state.promotions.find(p => p.id === action.payload.id);
        if (promotion) {
          promotion.status = 'Active';
        }
      })
      .addCase(updatePromotion.fulfilled, (state, action) => {
        const index = state.promotions.findIndex(p => p.id === action.payload.id);
        if (index !== -1) {
          state.promotions[index] = action.payload;
        }
      });
  },
});

export const { setFilters, setCurrentPromotion, clearError } = promotionsSlice.actions;
export default promotionsSlice.reducer;

